import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import FirstParty from './components/firstParty'

class App extends Component {

  constructor(props) {
    super(props)
    this.state = {

    }

  }

  render() {
    let viewHtml ="";

    viewHtml = <Router>
      <div>
      <Route component={FirstParty} exact path="/:key?" />
      </div>
    </Router>

    return (
      <div className="App">
        <header className="App-header">
        {viewHtml}
        </header>
      </div>
    );
  }
}

export default App;
